import { api } from "../lib/axios";

export const loginThirdParty = async (): Promise<{ token: string }> => {
  const { data } = await api.post("/auth/signin");
  return data;
};
